import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useRef } from 'react'
import { Button } from '~/components/ui/button'
import { cn } from '~/lib/utils';

import ProviderCard from '../Card/ProviderCard';

const MAX_PROVIDERS_DISPLAYED = 8; // Limit providers to reduce DOM size

function ProviderSliderSection({
  providers,
  heading,
  description,
  className = "",
  showProviderHeading
}: {
  providers: [];
  heading?: string;
  description?: string;
  className?: string
}) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: "left" | "right") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  // Limit providers to reduce DOM nodes
  const displayedProviders = Array.isArray(providers) ? providers.slice(0, MAX_PROVIDERS_DISPLAYED) : [];

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">{heading}</h2>
          <p className="text-md text-gray-[#181818] mt-1">
            {/* Work smarter with curated insights and trends. */}
            {description}
          </p>
        </div>
        <div className="hidden md:flex">
          <Button
            size="icon"
            variant="ghost"
            className="bg-gray-100 mr-3"
            aria-label='scroll left'
            onClick={() => scroll("left")}
          >
            <ChevronLeft />
          </Button>
          <Button
            size="icon"
            variant="ghost"
            aria-label='scroll right'
            className="bg-gray-100"
            onClick={() => scroll("right")}
          >
            <ChevronRight />
          </Button>
        </div>
      </div>

      <div className="relative mt-6 mb-2">
        <div
          ref={scrollRef}
          className={cn("flex overflow-x-auto space-x-3 scroll-smooth scrollbar-hide", className)}
        >
          {displayedProviders.map((provider: any, idx: number) => (
            <ProviderCard
              key={provider.sfid || idx}
              sfid={provider.sfid}
              name={provider.name}
              className="min-w-[300px] max-w-[300px]"
              image={provider.partnerLogo}
              backgroundImage={provider.x1920x480WebsiteHeroShot}
              description={provider.aboutPartner}
              totalProperties={provider.totalOnMarketProperties}
              workspaceProvider={provider}
              showProviderHeading={showProviderHeading}
              preferedCrown
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProviderSliderSection